var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',[_vm._v(_vm._s(_vm.icon))])
}
var staticRenderFns = []

export { render, staticRenderFns }